import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'dayjs', // usage：{{ value | dayjs:'format' }}
  pure: true,
  standalone: true,
})
export class DayjsPipe implements PipeTransform {
  transform(
    value: number | string | Date, 
    format: string = 'YYYY-MM-DD HH:mm:ss'
  ): string {
    if (!value) return '';

    let date: any;

    if (typeof value === 'number') {
      date = dayjs(value * 1000);
    } else if (value instanceof Date) {
      date = dayjs(value);
    } else if(typeof value === 'string') {
      if (!isNaN(Number(value))) {
        date = dayjs(Number(value) * 1000);
      } else {
        date = dayjs(value);
      }
    } else {
      return '';
    }

    // Check if date is valid
    if (!date.isValid()) {
      return '';
    }

    const formatted = date.format(format);
    // Ensure we don't return "Invalid date" or "unknown"
    if (formatted && !formatted.toLowerCase().includes('invalid') && !formatted.toLowerCase().includes('unknown')) {
      return formatted;
    }
    
    return '';
  }
}
